











import Vue from 'vue';
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { previewService } from '@/services/preview.service.ts';
import StampsComponent from '@/components/StampsComponent.vue';
import { IResponse, IPreview, ICompetition } from '@/interfaces/objects';

@Component({ components: {
    StampsComponent,
} })
export default class PreviewHome extends Vue {
    private type: string = '';
    private isLoading: boolean = true;
    private cKey: string = '';
    private pKey: string = '';
    private competition?: ICompetition;
    constructor() {
        super();
    }
    public created() {
        // Created
    }
    public async mounted() {
        // Mounted
        this.cKey = this.$route.params.companyKey;
        this.pKey = this.$route.params.previewKey;

        this.isLoading = true;
        await previewService.preview(this.cKey, this.pKey)
        .then((r: IResponse) => {
            if (r.success) {
                // tslint:disable-next-line:no-console
                const data = (r.data as IPreview);
                this.competition = data.competition as ICompetition;
                this.type = data.type;
            } else {
                // tslint:disable-next-line:no-console
                console.log('fail: ', r);
            }
        })
        .catch((c) => {
            // tslint:disable-next-line:no-console
            console.log('catch: ', c);
        });
        this.isLoading = false;
    }
}
